import { render, staticRenderFns } from "./CorrectCanvas.vue?vue&type=template&id=5f74e052&scoped=true"
import script from "./CorrectCanvas.vue?vue&type=script&lang=js"
export * from "./CorrectCanvas.vue?vue&type=script&lang=js"
import style0 from "./CorrectCanvas.vue?vue&type=style&index=0&id=5f74e052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f74e052",
  null
  
)

export default component.exports